const directiveAdmins = {
  all_directive_admins: 'All directives',
  create: 'Create New Directive',
  firstname: 'First Name',
  lastname: 'Last Name',
  lastname2nd: 'Second Last Name',
  email: 'Email',
  dni: 'DNI',
  birth_date: 'Birth Date',
  school: 'School',
  general_information: 'General Information',
  select_school: 'Select School',
  search_by_name: 'Search by name',
  edit_directive: 'Edit Directive',
  directive_information: 'Directive Information',
  impersonate: 'Impersonate',
  creation_date: 'Creation date',
  last_access: 'Last access',
  without_last_access: 'Has not logged in',
  state: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  create_new_information: '🔑 New password',
  empty: 'Empty',
};

export default directiveAdmins;
